<template>
  <v-container class="pa-0">
    <!-- <v-tooltip bottom>
      <template v-slot:activator="{ on, attrs }"> -->
    <v-btn
      class="mx-0"
      dark
      block
      color="primary"
      :loading="loading"
      @click="importExcel"
    >
      Import
      <!-- <v-icon dark>mdi-package-up</v-icon> -->
    </v-btn>
    <!-- </template>
      <span>Import</span>
    </v-tooltip> -->
    <alert-success
      :toggle-dialog="success"
      title="Import Success"
      message="Data was imported successfully"
    />
    <alert-error
      :toggle-dialog="error"
      title="Import Error!"
      :message="errorMessage"
    />
  </v-container>
</template>
<script>
  import readExcel from '@/extra-functions/readExcel.extra'
  import lostInventoryRepository from '@/repositories/lost-inventory.repository'
  import indexKeyGenerator from '@/extra-functions/index-key-generator.extra'
  import { dateFormatMixin } from '@/views/dashboard/mixins/helper.mixins'
  import searchDelay from '@/extra-functions/searchDelay.extra'
  import { mapState } from 'vuex'
  import { errorHandler } from '../../../../extra-functions/store.extra'
  import { apiVars } from '@/extra-functions/api-helper.extra'
  import stockRepository from '@/repositories/stock.repository'

  const errorDelay = searchDelay(100)
  const successDelay = searchDelay(100)
  const getStockDelay = searchDelay()
  const { dialog } = require('electron').remote
  export default {
    name: 'ImportLostInventories',
    components: {
      alertSuccess: () => import('@/views/dashboard/components/AlertSuccess'),
      alertError: () => import('@/views/dashboard/components/AlertError'),
    },
    data () {
      return {
        loading: false,
        success: false,
        errorMessage: [],
        error: false,
        ...apiVars('stock'),
      }
    },
    created () {
      this.getStock()
    },
    computed: {
      ...mapState({
        storeId: state => state.settings.storeId,
      }),
    },
    methods: {
      importExcel () {
        const options = {
          title: 'Import',
          filters: [{ name: 'Excel', extensions: ['xlsx'] }],
          buttonLabel: 'import',
        }
        dialog.showOpenDialog(null, options)
          .then(({ canceled, filePaths }) => {
            if (!canceled) {
              this.readExcel(filePaths[0])
            }
          })
      },
      async readExcel (filePath) {
        readExcel.loadExcel(filePath, this.importExcelFile)
      },
      importExcelFile (excelData) {
        if (!this.loading && !this.stockLoading) {
          this.loading = true
          const data = this.finalizeData(excelData)
          lostInventoryRepository.store(data)
            .then(() => {
              this.success = true
              successDelay(() => { this.success = false })
            })
            .catch(e => {
              this.error = true
              errorDelay(() => { this.error = false })
              this.errorMessage = errorHandler(e)
            })
            .then(() => { this.loading = false })
        }
      },
      finalizeData (data) {
        return data.map(e => {
          const dateSold = this.dateFormatSql(e.date_sold)
          return {
            ...e,
            date_sold: dateSold,
            index_key: indexKeyGenerator(),
            store_id: this.storeId,
            stock_id: this.stockList[e.stock_code],
          }
        })
      },
      getStock () {
        this.stockLoading = true
        getStockDelay(() => {
          stockRepository.storeAll(this.storeId)
            .then(({ data }) => { this.stockList = data })
            .catch(e => { this.stockErrors = errorHandler(e) })
            .then(() => { this.stockLoading = false })
        })
      },
    },
    mixins: [
      dateFormatMixin,
    ],
  }
</script>
